import { AfterViewInit, Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
// amCharts imports
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { BaseChartService } from '../../../../shared/services/base-chart.service';
import { BarChartData } from '../interfaces/bar-chart-data.interface';
import { CommonService } from '../../../../shared/services/common.service';
import { SpinnerService } from '../../../../shared/services/spinner.service';
import { Observable } from 'rxjs';
/**
 * Pyramid Graph Component
 * @author: PRachethan | 02-08-2025 
 */
@Component({
  selector: 'bi-pyramid-graph',
  standalone: false,
  templateUrl: './pyramid-graph.component.html',
  styleUrl: './pyramid-graph.component.scss'
})
export class PyramidGraphComponent implements OnInit, AfterViewInit, OnDestroy {
  private root!: am5.Root;
  data: BarChartData[] = [];
  private pyramidGraphReportSubscription: any;
  private isPyramidGraphViewInitialized = false;

  @Input() reportData: any = null;

  constructor(
    private zone: NgZone,
    private _baseChartService: BaseChartService,
    private _commonService: CommonService,
    private _spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.pyramidGraphReportSubscription = this._commonService.graphReportState.subscribe((data: any) => {
        if (data && data.reportData && Array.isArray(data.reportData) && data.reportData.length > 0) {
          this.reportData = data;
          console.log("Pyramid Graph Data", this.reportData);
          this.data = this._baseChartService.transformReportData(data);
          if (this.isPyramidGraphViewInitialized) {
            this.updateChart(this.data);
          }
        } else {
        }
      });
    });
  }

  ngAfterViewInit(): void {
    this.isPyramidGraphViewInitialized = true;
    if (this.reportData && this.reportData.reportData && Array.isArray(this.reportData.reportData) && this.reportData.reportData.length > 0) {
      this.zone.runOutsideAngular(() => {
        this.data = this._baseChartService.transformReportData(this.reportData);
        this.updateChart(this.data);
      });
    }
  }

  ngOnChanges(): void {
    if (this.reportData && this.reportData.reportData && Array.isArray(this.reportData.reportData) && this.reportData.reportData.length > 0 && this.isPyramidGraphViewInitialized) {
      this.zone.runOutsideAngular(() => {
        this.data = this._baseChartService.transformReportData(this.reportData);
        this.updateChart(this.data);
      });
    }
  }

  // Note: This is the same as the funnel graph
  // Please refer the funnel graph for more details
  // https://www.amcharts.com/docs/v5/charts/percent-charts/sliced-chart/pyramid-series/
  /* createChart(data: BarChartData[]) {
    // Check if the chart container exists
    const chartContainer = document.getElementById('pyramid-chartdiv');
    if (!chartContainer) {
      console.error('Pyramid Chart - Chart container not found! Make sure element with id "pyramid-chartdiv" exists');
      return;
    }

    try {
      // Create root element
      this.root = this._baseChartService.createRoot('pyramid-chartdiv');

      // Set themes
      this.root.setThemes([
        am5themes_Animated.new(this.root)
      ]);

      // Create chart
      let chart = this.root.container.children.push(am5percent.SlicedChart.new(this.root, {
        layout: this.root.verticalLayout
      }));

      // Create series
      let pyramidSeries = chart.series.push(am5percent.PyramidSeries.new(this.root, {
        orientation: "vertical",
        valueField: "value",
        categoryField: "category",
        valueIs: "height"
      }));

      // Configure tooltip properly with enhanced animation
      const tooltip = this._baseChartService.createStandardTooltip(this.root, 'pyramid', {
        showPercentage: true,
        showValue: true,
        showCategory: true
      });
      pyramidSeries.slices.template.set('tooltip', tooltip);
      
      // Transform data for pyramid chart
      const categoryField = this._baseChartService.getCategoryField(data);
      const valueFields = this._baseChartService.getValueFields(data);
      const firstValueField = valueFields[0];

      const pyramidData = data.map((item, index) => ({
        category: item[categoryField],
        value: Number(item[firstValueField]) || 0
      }));

      console.log('Pyramid Chart - Transformed Data:', pyramidData);

      // Sort data by value in descending order for pyramid effect
      pyramidData.sort((a, b) => Number(b.value) - Number(a.value));

      console.log('Pyramid Chart - Sorted Data:', pyramidData);

      // Set data
      pyramidSeries.data.setAll(pyramidData);

      // Play initial series animation
      pyramidSeries.appear();

      // Make stuff animate on load
      chart.appear(1000, 100);

    } catch (error) {
      console.error('Error creating pyramid chart:', error);
    }
  } */

   
  
createChart(_data_: BarChartData[]) {
  const chartContainer = document.getElementById('pyramid-chartdiv');
  if (!chartContainer) {
    console.error('Pyramid Chart - Chart container not found!');
    return;
  }
 
  try {
    // Create root
    this.root = this._baseChartService.createRoot('pyramid-chartdiv');
    this._baseChartService.attachExporting(this.root, { 
      filePrefix: 'pyramid',
      data: _data_
    });
 
    // Set themes
    this.root.setThemes([
      am5themes_Animated.new(this.root)
    ]);
 
    // Create chart
    let chart = this.root.container.children.push(
      am5percent.SlicedChart.new(this.root, {
        layout: this.root.verticalLayout
      })
    );
 
    // Create series
    let pyramidSeries = chart.series.push(
      am5percent.PyramidSeries.new(this.root, {
        orientation: "vertical",
        valueField: "value",
        categoryField: "category",
        valueIs: "height"
      })
    );
 
    // ✅ Simple working tooltip
    pyramidSeries.slices.template.setAll({
      tooltipText: "{category}: {value}",
      interactive: true,
      cursorOverStyle: "pointer"
    });
 
    // Transform data
    const categoryField = this._baseChartService.getCategoryField(_data_);
    const valueFields = this._baseChartService.getValueFields(_data_);
    const firstValueField = valueFields[0];
 
    const pyramidData = _data_.map((_item_) => ({
      category: _item_[categoryField],
      value: Number(_item_[firstValueField]) || 0
    }));
 
    // Sort descending
    pyramidData.sort((a, b) => b.value - a.value);
 
    // Set data
    pyramidSeries.data.setAll(pyramidData);

    // Add legend (one entry per slice)
    let legend = chart.children.push(
      this._baseChartService.createLegend(this.root)
    );

    this._baseChartService.setupLegendAnimation(legend);

    legend.set('maxHeight', 40);

    let markerTemplate = legend.markers.template;
    markerTemplate.set('width', 12);
    markerTemplate.set('height', 12);

    const updateLegend = () => legend.data.setAll(pyramidSeries.dataItems);
    setTimeout(() => updateLegend(), 100);

    // Appear animation
    pyramidSeries.appear();
    chart.appear(1000, 100);
  } catch (error) {
      console.error('Error creating pyramid chart:', error);
    }
  }
     

  private updateChart(data: BarChartData[]) {
    if (this.root) {
      this._baseChartService.disposeChart(this.root);
    }
    // Add a small delay to ensure proper disposal and DOM element availability
    setTimeout(() => {
      this.createChart(data);
    }, 100);
    
    // Update the chart data in the registry
    BaseChartService.updateActiveChartData(data);
  }

  ngOnDestroy(): void {
    // Hide spinner if it's still showing
    this._spinnerService.hide();
    this._baseChartService.disposeChart(this.root);
    if (this.pyramidGraphReportSubscription) {
      this.pyramidGraphReportSubscription.unsubscribe();
    }
  }
}
